<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    @if (!minimise) {
<i class="fa fa-minus-square-o" (click)="minimise=!minimise" title="Minimize"></i>
}
    @if (minimise) {
<i class="fa fa-plus-square-o" (click)="minimise=!minimise" title="Restore"></i>
}
    <i class="fa fa-times" (click)="modalClose()" title="Close"></i>
  </div>
</div>

<!-- Modal Body -->
@if (!minimise) {
<div class="modal-body">

@if (isLoading) {
<mat-progress-bar
                  color="primary"
                  mode="indeterminate">
</mat-progress-bar>
}

<div class="max-height">
  <section class="ap-p-spacing-6">
    <div class="ap-p-spacing-6">
      <table class="table table-hover table-bordered table-striped table-condensed">
        <thead class="a-thead">
          <tr>
            <th><b>LEID</b></th>
            <th><b>Tax Code</b></th>
            <th><b>Reporting Period</b></th>
            <th><b>Entity Name</b></th>
            <th><b>Functional Currency</b></th>
            <th><b>Exchange Rate</b></th>
            <th><b>Account Type</b></th>
          </tr>
        </thead>
        @if (firstList.length > 0) {
<tbody class="a-tbody tbody-regular tbody-hover entity-summary-body">
        @for (item of firstList; track $index) {
<tr>
          <td><b>{{ item.HO_LEID }}</b></td>
          <td><b>{{ item.HO_CDR_NO }}</b></td>
          <td><b>{{ item.HO_REPORTING_PERIOD }}</b></td>
          <td><b>{{ item.LE_NAME }}</b></td>
          <td><b>{{ item.HO_FUNCTIONAL_CURRENCY }}</b></td>
          <td><b>{{ item.US_WTD_AVG_RATE }}</b></td>
          <td><b>{{ item.ACCT_TYPE }}</b></td>
        </tr>
}
        </tbody>
}
      </table>
    </div>
  </section>
</div>

<div class="max-height">
  <section class="ap-p-spacing-6">
    <div class="ap-p-spacing-6">
      <table class="table table-hover table-bordered table-condensed">
        <thead class="a-thead">
          <tr>
            <th style="width:2%"  class="headerALign"></th>
            <th style="width:20%" class="headerALign"><b>Issue ID -- Issue Description</b></th>
            <th style="width:13%" class="headerALign"><b>Total</b></th>
            <th style="width:13%" class="headerALign"><b>Branch</b></th>
            <th style="width:13%" class="headerALign"><b>General</b></th>
            <th style="width:13%" class="headerALign"><b>FSI</b></th>
            <th style="width:13%" class="headerALign"><b>Passive</b></th>
            <th style="width:13%" class="headerALign"><b>US</b></th>
          </tr>
        </thead>
        @if (sourcingList.length > 0) {
<tbody class="a-tbody tbody-regular tbody-hover">
        <!--<ng-container>-->
          <tr>
            <td>
              @if (myScenarioCode === 'EXAM') {
<i class="fa fa-plus-circle color-green fa-lg pull-left"  style="cursor: pointer; margin-top: 4px;" data-toggle="tooltip" data-placement="right"  [attr.title]="toolTipMsgAdd"  data-trigger="hover" (click)="addSourcingRecord()"></i>
}
            </td>
          </tr>
          @for (item of sourcingList; track $index; let i = $index) {
<tr>
            <td>
              @if (item.ISSUE_KEY === 0) {
<div ></div>
}
                @if (item.ISSUE_KEY !== 0 && item.TOTAL === 0 ) {
<div><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" data-toggle="tooltip" data-placement="right" [attr.title]="toolTipMsgRemove"  data-trigger="hover" (click)="removeSourcingRecord(i)"></i></div>
}
            </td>
            <td class="headerALign">
              @if (item.OP_MODE === 'edit' ) {
<div >@if (item.ISSUE_ID_SHORT_DESC === '0--RAF Issue' ) {
<div><label>&nbsp;</label></div>
}@if (item.ISSUE_ID_SHORT_DESC !== '0--RAF Issue' ) {
<div><label>{{item.ISSUE_ID_SHORT_DESC}}</label></div>
}</div>
}
              @if (item.OP_MODE === 'add' ) {
<div>
                <mat-form-field class="field-full-width font-black-color"> <!-- class="font-black-color field-full-width mat-form-field-wrapper" -->

                  <mat-select name="issueDropdown" (selectionChange) = "onIssueChange($event, i)">
                    @for (option of issueList; track $index) {

                      <mat-option  [value]="option.ISSUE_ID">
                        {{option.ISSUE_ID_SHORT_DESC}}
                      </mat-option>
                    
}
                  </mat-select>
                </mat-form-field>
              </div>
}
            </td>
            <td class="amountALign"><label>{{item.TOTAL | currency:"$":'symbol': "1.0"}}</label></td>
            <td class="amountALign"><label>{{ item.BRANCH | currency:"$":'symbol': "1.0"}}</label></td>
            <!--<td><ap-form-field class="number-field" [type]="'inputNumber'"  [label]="'$'" [funType]="'typeTwo'" [(ngModel)]="item.GENERAL" matInputCommified></ap-form-field> </td>-->
            <!--<td><ap-form-field class="number-field" [type]="'inputNumber'"  [label]="'$'" [funType]="'typeTwo'" [(ngModel)]="item.FSI"></ap-form-field> </td>-->
            <!--<td><ap-form-field class="number-field" [type]="'inputNumber'"  [label]="'$'" [funType]="'typeTwo'" [(ngModel)]="item.PASSIVE"></ap-form-field> </td>-->
            <!--<td><ap-form-field class="number-field" [type]="'inputNumber'"  [label]="'$'" [funType]="'typeTwo'" [(ngModel)]="item.US"></ap-form-field> </td>-->
            <td class="amountALign">
              @if (myScenarioCode === 'EXAM' && item.ISSUE_KEY === 0) {
<div ><label>{{item.GENERAL | currency:"$":'symbol': "1.0"}}</label></div>
}
              @if ((myScenarioCode === 'RAF') || (myScenarioCode === 'EXAM' && item.ISSUE_KEY !== 0) ) {
<div><input matInput class="number-field a-text-input" style="text-align: right !important;" type="text" [(ngModel)]="item.GENERAL" (change)="makeDirty(i)"  (blur)="refreshSourcingTotal('GENERAL', i)" (keypress)="keyPressNumbers($event)" matInputCommified></div>
} <!-- ngModelChange -->
            </td>
            <td class="amountALign">
              @if (myScenarioCode === 'EXAM' && item.ISSUE_KEY === 0) {
<div ><label>{{item.FSI | currency:"$":'symbol': "1.0"}}</label></div>
}
              @if ((myScenarioCode === 'RAF') || (myScenarioCode === 'EXAM' && item.ISSUE_KEY !== 0) ) {
<div><input matInput class="number-field a-text-input" style="text-align: right !important;" type="text" [(ngModel)]="item.FSI" (change)="makeDirty(i)" (blur)="refreshSourcingTotal('FSI', i)" (keypress)="keyPressNumbers($event)" matInputCommified></div>
}
            </td>
            <td class="amountALign">
              @if (myScenarioCode === 'EXAM' && item.ISSUE_KEY === 0) {
<div ><label>{{item.PASSIVE | currency:"$":'symbol': "1.0"}}</label></div>
}
              @if ((myScenarioCode === 'RAF') || (myScenarioCode === 'EXAM' && item.ISSUE_KEY !== 0) ) {
<div><input matInput class="number-field a-text-input" style="text-align: right !important;" type="text" [(ngModel)]="item.PASSIVE" (change)="makeDirty(i)" (blur)="refreshSourcingTotal('PASSIVE',i)" (keypress)="keyPressNumbers($event)" matInputCommified></div>
}
            </td>
            <td class="amountALign">
              @if (myScenarioCode === 'EXAM' && item.ISSUE_KEY === 0) {
<div ><label>{{item.US | currency:"$":'symbol': "1.0"}}</label></div>
}
              @if ((myScenarioCode === 'RAF') || (myScenarioCode === 'EXAM' && item.ISSUE_KEY !== 0) ) {
<div><input matInput class="number-field a-text-input" style="text-align: right !important;" type="text" [(ngModel)]="item.US" (blur)="refreshSourcingTotal('US',i)" (change)="makeDirty(i)" (keypress)="keyPressNumbers($event)" matInputCommified></div>
}
            </td>
          </tr>
}
        <!--Total row-->
          <tr class="totalRow">
            <td></td>
            <td class="amountALign"><b>Total Basket Splits for all issues</b></td>
            <td class="amountALign"><b><label>{{calcTotal('TOTAL') | currency:"$":'symbol': "1.0"}}</label></b></td>
            <td class="amountALign"><b><label>{{calcTotal('BRANCH') | currency:"$":'symbol': "1.0"}}</label></b></td>
            <td class="amountALign"><b><label>{{calcTotal('GENERAL') | currency:"$":'symbol': "1.0"}}</label></b></td>
            <td class="amountALign"><b><label>{{calcTotal('FSI') | currency:"$":'symbol': "1.0"}}</label></b></td>
            <td class="amountALign"><b><label>{{calcTotal('PASSIVE') | currency:"$":'symbol': "1.0"}}</label></b></td>
            <td class="amountALign"><b><label>{{calcTotal('US') | currency:"$":'symbol': "1.0"}}</label></b></td>
          </tr>
        </tbody>
}
      </table>
    </div>
  </section>
</div>

</div>
}<!-- /modal-body -->

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          (click)="saveF8865M2K1SourcingData()"
          [disabled]="isLoading">
    @if (isLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
    Save
  </button>
  <button class="cancel-button" (click)="modalClose()">Cancel</button>
</div>
